import React from 'react';
import '../less/e-receipt.less';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../../../auxiliary-components/shared/HeroBlock';
import BusinessOrder from '../../../../../../BusinessOrder';
import AdditionalProduct from './../../../../../../../auxiliary-components/shared/AdditionalProductBlock';
import additional_cards from '../enums/additional_cards_data.json';
import { getUrl } from "utils/corploansUrl";
import { eReceiptLink } from '../../../../../../../services/urls/urls';
import additional_product_img_1 from '../img/additional_product_img_1.png';
import additional_product_img_2 from '../img/additional_product_img_2.png';
import serviceUsageItems from '../enums/service_usage_items.json';
import { getSafeLinkProps } from '../../../../../../../helpers/utils/urlSecurity';

export default function template() {
    const page = 'business-gov-receipt';

    const imagesMap = {
      additional_product_img_1,
      additional_product_img_2
    };

    const hero_data = {
      title: "BUSINESS_GOV_RECEIPT_NEW_HERO_TITLE",
      text: "BUSINESS_GOV_RECEIPT_NEW_HERO_TEXT",
    }

    const additionalCards = additional_cards.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    return (
      <div className="business-gov-receipt">
        <Hero
          data={hero_data}
          img={hero_img}
        />
        <div className="content">
          <div className="general-info">
            <div className="container">
              <h2 className="general-info__title">{this.l10n('BUSINESS_GOV_RECEIPT_GENERAL_INFO_TITLE')}</h2>
              <div className="general-info__text">
                <p>
                  {this.l10n('BUSINESS_GOV_RECEIPT_GENERAL_INFO_TEXT_01')} 
                  <a {...getSafeLinkProps(eReceiptLink, { target: '_blank' })}>{this.l10n('BUSINESS_GOV_RECEIPT_GENERAL_INFO_LINK')}</a>
                  {this.l10n('BUSINESS_GOV_RECEIPT_GENERAL_INFO_TEXT_02')} 
                </p>
                <p>{this.l10n('BUSINESS_GOV_RECEIPT_GENERAL_INFO_TEXT_03')}</p>
              </div>
              <h2 className="general-info__subtitle">{this.l10n('BUSINESS_GOV_RECEIPT_GENERAL_INFO_SUBTITLE')}</h2>
              <ul className="general-info__list">
                <li>{this.l10n('BUSINESS_GOV_RECEIPT_GENERAL_INFO_LIST_01')}</li>
                <li>{this.l10n('BUSINESS_GOV_RECEIPT_GENERAL_INFO_LIST_02')}</li>
                <li>{this.l10n('BUSINESS_GOV_RECEIPT_GENERAL_INFO_LIST_03')}</li>
                <li>{this.l10n('BUSINESS_GOV_RECEIPT_GENERAL_INFO_LIST_04')}</li>
                <li>{this.l10n('BUSINESS_GOV_RECEIPT_GENERAL_INFO_LIST_05')}</li>
              </ul>
            </div>
          </div>
          <div className="service-usage">
            <div className="container">
              <h2 className="service-usage__title">{this.l10n('BUSINESS_GOV_RECEIPT_NEW_SERVICE_USAGE_TITLE')}</h2>
              <div className="service-usage__body">
                {serviceUsageItems.map((item, index) => (
                  <div key={index} className="service-usage__item item-service-usage">
                    <div className="item-service-usage__title">{this.l10n(item.title)}</div>
                    <div className="item-service-usage__text">{this.l10n(item.text)}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <AdditionalProduct
            items={additionalCards}
            title={'BUSINESS_GOV_RECEIPT_ADDITIONAL_PRODUCT_TITLE'}
          />
        </div>
      </div>
    );
}
